import { useQuery } from 'react-query';

import {
  AdvocacyStatus,
  getAdvocacyStatus,
} from 'services/linkedinAdvocacyStatus';

export const ADVOCACY_STATUS_QUERY_KEY = 'linkedinAdvocacyStatus';

/**
 * The logged-in advocate's LinkedIn Advocacy connection status, or undefined
 * while it is unknown.
 *
 * web-be evaluates linkedinAdvocacyAuth and answers 404 FEATURE_DISABLED when
 * it is off, so a failure of any kind leaves the status unknown, and unknown
 * shows no banner. Not retried, nor refetched on focus or reconnect, so an
 * unmigrated company costs one request per visit.
 */
export const useAdvocacyStatus = (
  token: string | null | undefined,
): AdvocacyStatus | undefined => {
  const query = useQuery<AdvocacyStatus>({
    // Keyed by session: switching advocate company swaps the token without a
    // reload, and the new company's connection must be asked for afresh.
    queryKey: [ADVOCACY_STATUS_QUERY_KEY, token],
    queryFn: () => getAdvocacyStatus(token as string),
    enabled: !!token,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  // Only an answer fetched during this visit counts: a needs_reconnect cached
  // from before the advocate reconnected would show the banner again.
  return query.isSuccess && query.isFetchedAfterMount ? query.data : undefined;
};
